/* =============================================================
   Pawlino Effekte – Laufzeit
   Scroll-Reveal, Bild-Zoom, Buchstaben-Headline, Produktkarten,
   Linien & Zähler, Sticky-Story-Sync.
   Hinweis: Die Pfoten-Fortschrittsleiste wurde am 18.8. entfernt.
   ============================================================= */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;

  if (window.__pawlinoFx) return;
  window.__pawlinoFx = true;

  // Im Theme-Editor und bei reduzierter Bewegung: keine Effekte
  if (root.classList.contains('shopify-design-mode')) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  root.classList.add('pw-fx');

  var main = doc.getElementById('MainContent') || doc.body;

  /* ---------- Beobachter ---------- */
  var ioReveal = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('pw-in');
        ioReveal.unobserve(e.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });

  var ioLetters = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('pw-go');
        ioLetters.unobserve(e.target);
      }
    });
  }, { threshold: 0.4 });

  var ioCount = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        runCounter(e.target);
        ioCount.unobserve(e.target);
      }
    });
  }, { threshold: 0.5 });

  /* ---------- 06 Buchstaben-Headline ---------- */
  function splitLetters(h) {
    if (h.dataset.pwDone) return;
    if (h.children.length > 0) return; // nur reiner Text
    var text = (h.textContent || '').trim();
    if (!text || text.length > 80) return;
    h.dataset.pwDone = '1';
    h.classList.add('pw-letters');
    h.setAttribute('aria-label', text);

    var holder = doc.createElement('span');
    holder.setAttribute('aria-hidden', 'true');
    var words = text.split(/\s+/);
    var i = 0;
    words.forEach(function (w, wi) {
      var ws = doc.createElement('span');
      ws.className = 'pw-w';
      for (var c = 0; c < w.length; c++) {
        var s = doc.createElement('span');
        s.className = 'pw-l';
        s.style.setProperty('--pw-i', i++);
        s.textContent = w.charAt(c);
        ws.appendChild(s);
      }
      holder.appendChild(ws);
      if (wi < words.length - 1) holder.appendChild(doc.createTextNode(' '));
    });
    h.textContent = '';
    h.appendChild(holder);
    ioLetters.observe(h);
  }

  function prepLetters() {
    var heads = main.querySelectorAll('h1');
    var count = 0;
    for (var i = 0; i < heads.length && count < 2; i++) {
      if (heads[i].closest('form, dialog')) continue;
      splitLetters(heads[i]);
      count++;
    }
    if (!heads.length) {
      var first = main.querySelector('.shopify-section h2');
      if (first && !first.closest('form, dialog')) splitLetters(first);
    }
  }

  /* ---------- 03 Bild-Zoom ---------- */
  var zoomImgs = [];

  function prepZoom(scope) {
    if (zoomImgs.length >= 6) return;
    var imgs = (scope || main).querySelectorAll('img:not(.pw-zoom)');
    for (var i = 0; i < imgs.length && zoomImgs.length < 6; i++) {
      var img = imgs[i];
      if (img.closest('.card-gallery, product-card, [class*="media-gallery"], dialog, form, [data-pw-story], .paw-hero')) continue;
      var w = img.clientWidth;
      var h = img.clientHeight;
      if (w < Math.min(window.innerWidth * 0.62, 620) || h < 240) continue;
      var parent = img.parentElement;
      var hops = 0;
      var wrap = null;
      while (parent && hops < 2) {
        if (parent.children.length === 1) { wrap = parent; break; }
        parent = parent.parentElement;
        hops++;
      }
      if (!wrap || wrap === main || wrap === doc.body) continue;
      wrap.classList.add('pw-zoom-parent');
      img.classList.add('pw-zoom');
      zoomImgs.push(img);
    }
  }

  function updateZoom(vh) {
    for (var i = 0; i < zoomImgs.length; i++) {
      var img = zoomImgs[i];
      var r = img.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) continue;
      var p = (vh - r.top) / (vh + r.height);
      p = Math.max(0, Math.min(1, p));
      img.style.setProperty('--pw-zs', (1.1 - 0.1 * p).toFixed(4));
    }
  }

  /* ---------- 08 Zähler ---------- */
  function runCounter(el) {
    if (el.dataset.pwRunning) return;
    el.dataset.pwRunning = '1';
    var target = parseFloat(el.getAttribute('data-pw-count')) || 0;
    var suffix = el.getAttribute('data-pw-suffix') || '';
    var dur = 1100;
    var start = null;
    function frame(t) {
      if (start === null) start = t;
      var p = Math.min(1, (t - start) / dur);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(eased * target).toLocaleString('de-CH') + suffix;
      if (p < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  /* ---------- 01 Scroll-Reveal ---------- */
  var REVEAL_SEL = 'h1, h2, h3, h4, p, blockquote, .button, a.button, product-card, .collection-card, .resource-card, .pw-zoom-parent';

  function prepRevealIn(sectionEl) {
    var els = sectionEl.querySelectorAll(REVEAL_SEL);
    var idx = 0;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.dataset.pwRv) continue;
      if (el.closest('form, dialog, [data-pw-story]')) continue;
      if (el.classList.contains('pw-letters')) continue;
      el.dataset.pwRv = '1';
      if (el.parentElement && el.parentElement.closest('.pw-rv')) continue; // keine Verschachtelung
      el.classList.add('pw-rv');
      el.style.setProperty('--pw-d', (Math.min(idx, 8) * 70) + 'ms');
      idx++;
      ioReveal.observe(el);
    }
  }

  /* ---------- 08 Linien ---------- */
  function prepLines(scope) {
    var els = (scope || main).querySelectorAll('hr, .divider');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.dataset.pwLine) continue;
      if (el.closest('form, dialog')) continue;
      el.dataset.pwLine = '1';
      el.classList.add('pw-line');
      ioReveal.observe(el);
    }
  }

  function prepCounters(scope) {
    var els = (scope || main).querySelectorAll('[data-pw-count]');
    for (var i = 0; i < els.length; i++) {
      if (els[i].dataset.pwC) continue;
      els[i].dataset.pwC = '1';
      ioCount.observe(els[i]);
    }
  }

  /* ---------- 07 Lebendige Produktkarten ---------- */
  function bindCard(card) {
    if (card.dataset.pwCard) return;
    card.dataset.pwCard = '1';

    var gallery = card.querySelector('.card-gallery');
    var link =
      card.querySelector('a[ref="cardGalleryLink"]') ||
      card.querySelector('a[ref="productCardLink"]') ||
      card.querySelector('a[href*="/products/"]');

    var themeHandlesHover = gallery && gallery.hasAttribute('on:pointerenter');
    if (!themeHandlesHover) {
      card.addEventListener('pointerenter', function (e) {
        if (typeof card.previewImage === 'function') card.previewImage(e);
      });
      card.addEventListener('pointerleave', function (e) {
        if (typeof card.resetImage === 'function') card.resetImage(e);
      });
    }

    if (gallery && link && link.href && !gallery.querySelector('.pw-card-cta')) {
      var cta = doc.createElement('a');
      cta.className = 'pw-card-cta';
      cta.href = link.href;
      cta.textContent = 'Personalisieren';
      cta.setAttribute('tabindex', '-1');
      cta.setAttribute('aria-hidden', 'true');
      gallery.appendChild(cta);
    }
  }

  function prepCards(scope) {
    var cards = (scope || main).querySelectorAll('product-card');
    for (var i = 0; i < cards.length; i++) bindCard(cards[i]);
  }

  /* ---------- 05 Sticky-Story: aktiven Schritt markieren ---------- */
  function prepStories(scope) {
    var stories = (scope || main).querySelectorAll('[data-pw-story]');
    stories.forEach(function (story) {
      if (story.dataset.pwS) return;
      story.dataset.pwS = '1';
      var steps = story.querySelectorAll('[data-pw-step]');
      var imgs = story.querySelectorAll('[data-pw-story-img]');
      if (!steps.length || !imgs.length) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var key = e.target.getAttribute('data-pw-story-img');
          steps.forEach(function (s) {
            s.classList.toggle('pw-active', s.getAttribute('data-pw-step') === key);
          });
        });
      }, { rootMargin: '-35% 0px -35% 0px', threshold: 0 });
      imgs.forEach(function (im) { io.observe(im); });
    });
  }

  /* ---------- Scroll-Schleife (Bild-Zoom) ---------- */
  var ticking = false;
  function onScroll() {
    ticking = false;
    updateZoom(window.innerHeight);
  }
  function requestTick() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(onScroll);
    }
  }
  window.addEventListener('scroll', requestTick, { passive: true });
  window.addEventListener('resize', requestTick, { passive: true });

  /* ---------- Aufbau + Absicherung bei dynamischen Updates ---------- */
  function scan(scope) {
    prepLetters();
    prepZoom(scope);
    prepStories(scope);
    prepCards(scope);
    prepLines(scope);
    prepCounters(scope);
    var container = scope || main;
    var sections = container.querySelectorAll('.shopify-section');
    if (sections.length) {
      sections.forEach(prepRevealIn);
    } else {
      prepRevealIn(container);
    }
  }

  // Sicherheitsnetz: nie Inhalte dauerhaft verstecken
  setInterval(function () {
    var pending = main.querySelectorAll('.pw-rv:not(.pw-in)');
    if (!pending.length) return;
    var vh = window.innerHeight;
    for (var i = 0; i < pending.length; i++) {
      var r = pending[i].getBoundingClientRect();
      if (r.top < vh * 1.05 && r.bottom > -20) pending[i].classList.add('pw-in');
    }
  }, 1800);

  var moDebounce;
  new MutationObserver(function () {
    clearTimeout(moDebounce);
    moDebounce = setTimeout(function () { scan(); }, 250);
  }).observe(main, { childList: true, subtree: true });

  function start() {
    scan();
    requestTick();
  }
  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
